import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Text from '@/components/Text';

const NoGitHubDataPlaceholder = () => {
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 rounded-lg bg-neutral-900">
      <FontAwesomeIcon icon={faGithub} size="4x" />
      <Text className="whitespace-pre text-center">
        Provide the link to this {'\n'} candidate’s GitHub profile to {'\n'}
        upload their data.
      </Text>
    </div>
  );
};

export default NoGitHubDataPlaceholder;
